import React from 'react';
import Header from '../component/Header'
import Footer from '../component/Footer';
import SignupStepComp from '../component/SignupStepComp';
import '../scss/signup-step.scss' 
function SignupStep() {

  return (
    <>
      <main className='signup-step-page'>
        <Header />       
       <div className='signup-step-box'>
        <SignupStepComp />
       </div>
      </main>
      <Footer />
    </>
  )
}
export default SignupStep 


